export default "__VITE_ASSET__BfpIwgBy__"